import React, { useState } from "react"
import PropTypes from "prop-types"

const StandardDate = props => {
  /* locale should be like it-IT or en-US
     date should be anything parsable by Date.parse. E.g. '2021-09-14T07:54:55' */
  const { className, dateGmt, modifiedGmt, locale, formatOptions } = props

  const toFriendlyDate = (date, locale) => {
    if (!date || !locale) {
      return null
    }
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString
    return new Date(Date.parse(date)).toLocaleDateString(
      locale,
      formatOptions[locale] ? formatOptions[locale] : undefined
    )
  }

  const [friendlyPublishDate] = useState(() => {
    return dateGmt && locale ? toFriendlyDate(dateGmt, locale) : null
  })
  const [friendlyModifiedDate] = useState(() => {
    return dateGmt && locale ? toFriendlyDate(modifiedGmt, locale) : null
  })

  return dateGmt || modifiedGmt ? (
    <div className={className}>
      <span className="posted-on">
        {dateGmt && (
          <time className="date-published" dateTime={dateGmt}>
            {friendlyPublishDate}
          </time>
        )}
        {modifiedGmt && (
          <time className="date-modified" dateTime={modifiedGmt}>
            {friendlyModifiedDate}
          </time>
        )}
      </span>
    </div>
  ) : null
}

StandardDate.propTypes = {
  className: PropTypes.string,
  dateGmt: PropTypes.string,
  modifiedGmt: PropTypes.string,
  locale: PropTypes.string,
  formatOptions: PropTypes.object,
}

StandardDate.defaultProps = {
  formatOptions: {
    "it-IT": {
      day: "numeric",
      month: "long",
      year: "numeric",
    },
  },
}

export default StandardDate
